import { Form, Formik } from "formik";
import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import CustomerInfoRetail from "./components/CustomerInfoRetail";
import FacilityInfo from "./components/FacilityInfo";
import CustomerInfoCor from "./components/CustomerInfoCor";
import CustomerInfoCorExisting from "./components/CustomerInfoCorExisting";
import CustomerInfoCorNew from "./components/CustomerInfoCorNew";
import {
  corInitValue,
  corValidationSchema,
  corExistingValidationSchema,
  corNewValidationSchema,
  retailInitValue,
  retailValidationSchema,
} from "./initValue";
import "./step-input.style.scss";

export default class StepInput extends Component {
  render() {
    const { type, bankType, onSubmit, formValues, loading, prefillData } =
      this.props;
    const defaultValue = type === "retail" ? retailInitValue : corInitValue;
    // Always merge prefillData into defaults so popup fields are pre-populated
    const initValue = { ...defaultValue, ...formValues };
    let validationSchema;
    if (type === "retail") {
      validationSchema = retailValidationSchema;
    } else if (bankType === "existing") {
      validationSchema = corExistingValidationSchema;
    } else if (bankType === "new") {
      validationSchema = corNewValidationSchema;
    } else {
      validationSchema = corValidationSchema;
    }
    let CustomerInfoComponent;
    if (type === "retail") {
      CustomerInfoComponent = <CustomerInfoRetail formValues={initValue} />;
    } else if (bankType === "existing") {
      CustomerInfoComponent = (
        <CustomerInfoCorExisting formValues={initValue} />
      );
    } else if (bankType === "new") {
      CustomerInfoComponent = <CustomerInfoCorNew formValues={initValue} />;
    } else {
      CustomerInfoComponent = <CustomerInfoCor formValues={initValue} />;
    }
    return (
      <div style={{ padding: "0 2rem" }}>
        <Formik
          initialValues={initValue}
          onSubmit={async (values) => {
            onSubmit(values);
          }}
          validationSchema={validationSchema}
        >
          <Form>
            <Grid fluid>
              {CustomerInfoComponent}
              <div style={{ height: 16 }}></div>
              <FacilityInfo type={type} prefillData={prefillData} />
            </Grid>
            <div className="btns">
              <button
                type="button"
                className="btn btn-secondary btn-prev"
                onClick={this.props.onPrev}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-next"
                disabled={loading}
              >
                {loading ? "Processing..." : "Next"}
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/StepInput.js